import { makeStyles } from '@mui/styles';
import { NextTheme } from '../../../layout/theme-next/provider';
import { lineItemStyles } from '../common/styles';

export default makeStyles((theme: NextTheme) => ({
  ...lineItemStyles(theme),
}));
